<template>
  <div class="card-con pr" v-bind="$attrs">
    <div v-if="$attrs.tagTitle" class="pa tag-con">
      <img class="pa" src="../img/icon_tag.png" />
      <div class="u-flex-col pr u-text-center">
        <h5><small>￥</small>{{ $attrs.tagTitle }}</h5>
        <p>预估价值</p>
      </div>
    </div>

    <!-- title -->
    <div class="u-flex-col card-con-title">
      <h4>
        {{ $attrs.title }}
        <span v-if="$attrs.subTitle">{{ $attrs.subTitle }}</span>
      </h4>
      <p v-if="$attrs.subInfoTitle">{{ $attrs.subInfoTitle }}</p>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Card',
  data() {
    return {}
  },
  created() {
    console.log(this.$attrs)
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.card-con {
  margin-top: 0.28rem;
  background: #fff;
  border-radius: 0.16rem;
  padding: 0.24rem 0.3rem 0.3rem;

  .tag-con {
    right: 0.22rem;
    top: 0;
    width: 1.2rem;
    height: 0.76rem;
    font-size: 0.36rem;
    font-weight: normal;
    font-size: 0.2rem;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #fcdeb6;

    > img {
      top: -0.08rem;
      right: 0;
      width: 100%;
    }

    > div {
      z-index: 1;
    }

    h5 {
      font-size: 0.36rem;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: bold;
      letter-spacing: -0.01rem;
      margin-top: -0.13rem;
      margin-bottom: -0.13rem;

      small {
        font-size: 0.22rem;
      }
    }
  }

  .card-con-title {
    h4 {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: normal;
      color: #1f2121;

      > span,
      & + p {
        color: rgba(31, 33, 33, 0.5);
        font-size: 0.24rem;
        font-family: HiraginoSansGB, HiraginoSansGB-Regular;
        font-weight: normal;
      }
    }
  }
}
</style>
